module.exports = __webpack_public_path__ + "static/media/users.875e3b18.svg";